module.exports = "/_next/static/images/bags-bd97ff9b1bec793af5ceedc2f6e24d6e.png";